import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Bob",
  "description": "",
  "published": "2007-03-13T00:00:00.000Z",
  "redirect_from": ["/blog/bob/swizec/263"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For some odd reason I can't help but find this video extremely funny ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      